module.exports = __webpack_public_path__ + "img/e-gift.e2722b0.jpg";